import { listKidSkillsCatalog } from '../../../../types/kidSkillsCatalog.js';
import type { KidSkillPublic } from '../types/kidSkill.js';

/** Mirrors backend catalog for offline / failed GET fallback. */
export const KID_SKILLS_CATALOG_FALLBACK: KidSkillPublic[] = listKidSkillsCatalog();
